(() => {
  'use strict';
  if (customElements.get('ud-faq-accordion')) return;

  let activeAccordions = 0;

  class FaqAccordion extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.animations = new Map();
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.addEventListener('click', event => {
        const summary = event.target.closest('summary');
        if (!summary || summary.parentElement.parentElement !== this) return;
        event.preventDefault();
        const row = summary.parentElement;
        const prior = this.animations.get(row);
        const opening = prior ? !prior.opening : !row.open;
        if (opening) {
          for (const other of this.querySelectorAll(':scope > details')) {
            if (other !== row && (other.open || this.animations.has(other))) this.animateRow(other, false, true);
          }
        }
        this.animateRow(row, opening);
      }, {signal: this.controller.signal});
      this.reducedMotion.addEventListener?.('change', () => {
        if (this.reducedMotion.matches) this.finishAnimations();
      }, {signal: this.controller.signal});
    }

    animateRow(row, opening, switching = false) {
      const reveal = row.querySelector('.faq-reveal');
      const content = row.querySelector('.faq-answer');
      const prior = this.animations.get(row);
      if (!this.reducedMotion.matches && reveal.animate) this.suppressScrollAnchoring(true);
      const startHeight = row.open ? reveal.getBoundingClientRect().height : 0;
      const contentStyle = prior ? getComputedStyle(content) : null;
      const startOpacity = contentStyle ? contentStyle.opacity : (opening ? 0 : 1);
      const startTransform = contentStyle ? contentStyle.transform : 'translateY(-10px)';
      if (prior) {
        prior.height.cancel();
        prior.content?.cancel();
        this.animations.delete(row);
      }
      if (this.reducedMotion.matches || !reveal.animate) {
        row.open = opening;
        this.suppressScrollAnchoring(this.animations.size > 0);
        return;
      }
      if (opening) row.open = true;
      const height = reveal.animate(
        [{height: startHeight + 'px'}, {height: (opening ? content.getBoundingClientRect().height : 0) + 'px'}],
        {duration: opening || switching ? 640 : 240, easing: opening || switching ? 'cubic-bezier(0.22, 1, 0.36, 1)' : 'cubic-bezier(0.4, 0, 0.6, 1)', fill: 'both'}
      );
      const contentAnimation = opening ? content.animate(
        [{opacity: startOpacity, transform: startTransform}, {opacity: 1, transform: 'translateY(0)'}],
        {duration: 460, delay: 90, easing: 'ease-out', fill: 'both'}
      ) : null;
      this.animations.set(row, {height, content: contentAnimation, opening});
      this.suppressScrollAnchoring(true);
      height.finished.then(() => {
        if (this.animations.get(row)?.height !== height) return;
        if (!opening) row.open = false;
        height.cancel();
        contentAnimation?.cancel();
        this.animations.delete(row);
        this.suppressScrollAnchoring(this.animations.size > 0);
      }).catch(() => {});
    }

    suppressScrollAnchoring(active) {
      if (!!this.scrollAnchoringSuppressed === active) return;
      this.scrollAnchoringSuppressed = active;
      activeAccordions += active ? 1 : -1;
      document.documentElement.classList.toggle('ud-faq-is-animating', activeAccordions > 0);
    }

    finishAnimations() {
      for (const [row, animation] of this.animations) {
        row.open = animation.opening;
        animation.height.cancel();
        animation.content?.cancel();
      }
      this.animations.clear();
      this.suppressScrollAnchoring(false);
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.finishAnimations();
    }
  }

  customElements.define('ud-faq-accordion', FaqAccordion);
})();
